import { Operator, Call, PaginatedApi, CallStatus } from './../../models/models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth';
import { OperatorProvider } from '../operator/operator';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class CallsProvider {
  baseUrl: string
  constructor(
    public http: HttpClient,
    private user: UserAuthProvider<any>,
    private readonly operatorProvider: OperatorProvider) {
    this.baseUrl = this.user.config.baseURL
  }

  getCalls(isDone: boolean, deal?: number) {
    return this.operatorProvider.currentOperator.pipe(
      take(1),
      switchMap((operator: Operator) => {
        let params: { [param: string]: string } = {}
        params.scheduled_by = `${operator.id}`
        params.statuses = isDone ? `${CallStatus.DONE},${CallStatus.CANCEL},${CallStatus.LEAVED}` :  `${CallStatus.PLANNED}`
        if (deal) {
          params.deal = `${deal}`
        }
        return this.http.get<PaginatedApi<Call>>(this.baseUrl + "api/crm/calls/", { params: params })
      })
    )
  }

  setStatus(callID: number, status: CallStatus) {
    return this.http.patch<Call>(`${this.baseUrl}api/crm/calls/${callID}/`, {status: status})
  }

  getNextCalls(url: string){
    return this.http.get<PaginatedApi<Call>>(url)
  }

  createCall(deal: number, datetime: string, notes?: string) {
    return this.operatorProvider.currentOperator.pipe(
      take(1),
      switchMap((operator: Operator) => {
        let body: { [param: string]: string } = {}
        body.operator = `${operator.id}`
        body.scheduled_by = `${operator.id}`
        body.deal = `${deal}`
        body.schedule_datetime = datetime
        if (notes) {
          body.notes = notes
        }
        return this.http.post<Call>(this.baseUrl + "api/crm/calls/", body)
      })
    )
  }

}



// WEBPACK FOOTER //
// ./src/providers/api/calls.provider.ts